'use strict';

class inputNumberCounter {
  constructor(elem) {
    this.elem = elem;
    this.isNoLabel = typeof this.elem.dataset.jsInputCounterNolabel !== 'undefined';
    this.counterInput = this.elem.querySelector('.js-input-counter-label');
    this.counterLabelWord = !this.isNoLabel ? this.elem.querySelector('.js-input-counter-label').dataset.counterLabel : '';
    this.counterFields = this.elem.querySelectorAll('.js-input-counter-field');
    this.counterValues = this.elem.querySelectorAll('.js-input-counter-value');

    this.events();
  }

  total() {
    let valueArray = [...this.counterValues].map(elem => {
      return parseInt(elem.value);
    });

    let total = valueArray.reduce((previousValue, currentValue) => {
      return previousValue + currentValue;
    });

    if (this.counterLabelWord !== '') {
      this.counterInput.value = total + ' ' + this.counterLabelWord;
    } else {
      this.counterInput.value = total;
    }
    this.counterInput.setAttribute('data-total-capacity', total);

    if(!this.isNoLabel) {
      this.counterInput.dispatchEvent(new Event('change'));
    }
  }

  events() {
    for(let counterField of this.counterFields) {
      const counterValue = counterField.querySelector('.js-input-counter-value');
      let startValue = parseInt(counterValue.value);
      const counterPlus = counterField.querySelector('.js-input-counter-plus');
      const counterLess = counterField.querySelector('.js-input-counter-less');
      const valueMin = parseInt(counterValue.getAttribute('min'));
      const valueMax = parseInt(counterValue.getAttribute('max'));

      (Number.isInteger(valueMin) && startValue > valueMin) && counterLess.removeAttribute("disabled");
      (Number.isInteger(valueMax) && startValue >= valueMax) && counterPlus.setAttribute("disabled", "");

      counterValue.addEventListener('change', (e) => {
        const counterPlus = e.target.parentElement.querySelector('.js-input-counter-plus');
        const counterLess = e.target.parentElement.querySelector('.js-input-counter-less');
        const currentValue = parseInt(e.currentTarget.value);
        const minValue = parseInt(e.currentTarget.min);
        const maxValue = parseInt(e.currentTarget.max);
        (parseInt(currentValue) <= minValue) ? counterLess.setAttribute("disabled", "") : counterLess.removeAttribute("disabled");
        (parseInt(currentValue) >= maxValue) ? counterPlus.setAttribute("disabled", "") : counterPlus.removeAttribute("disabled");
        
        startValue = parseInt(currentValue);
      });

      const disabledChangeObserver = new MutationObserver((mutationList, observer) => {
        // When counterValue is disabled, disable counterPlus and counterLess.
        // For that, we aritificially add a custom attribute to the counterPlus and counterLess
        // to know if they were disabled by the counterValue.
        // As the only way to disable counterPlus and counterLess is by clicking on them, we can
        // safely remove the disabled attribute when the counterValue is enabled.
        for (const mutation of mutationList) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'disabled') {
            if (mutation.target.disabled) {
              if (!counterPlus.disabled) {
                counterPlus.setAttribute('disabled', '');
                counterPlus.setAttribute('custom-disabled', '');
              }
              if (!counterLess.disabled) {
                counterLess.setAttribute('disabled', '');
                counterLess.setAttribute('custom-disabled', '');
              }
            } else {
              if (counterPlus.hasAttribute('custom-disabled')) {
                counterPlus.removeAttribute('disabled');
                counterPlus.removeAttribute('custom-disabled');
              }
              if (counterLess.hasAttribute('custom-disabled')) {
                counterLess.removeAttribute('disabled');
                counterLess.removeAttribute('custom-disabled');
              }
            }
          }
        }
      })
      disabledChangeObserver.observe(counterValue, {attributes: true, childlist: false, subtree: false});

      counterPlus.addEventListener('click', e => {
        counterValue.value++;
        this.total();
        counterValue.dispatchEvent(new Event('change'));
      });      
      counterLess.addEventListener('click', e => {
        counterValue.value--;
        this.total();
        counterValue.dispatchEvent(new Event('change'));
      });
    }
  }
}


const inputCounters = document.querySelectorAll('.js-input-counter');

for (let inputCounter of inputCounters) {
  inputCounter.collapse = new inputNumberCounter(inputCounter)
}
